import Api from "@/services/Api"

export default {
  getMeritOrderProducts (params) {
    return Api().get("meritOrderProducts", { params })
  },
  save (params) {
    return Api().post("meritOrderProducts", params)
  }
}



// WEBPACK FOOTER //
// ./src/services/MeritOrderProductsService.js